import * as user from '../api/users';
import { actionTypes } from './index';
import { addNotification } from './api-notifications';

export const getCalls = (isProCalls, page = 1, shouldBeReloaded = true, shouldScrollUp = true) => async (dispatch, getState) => {
  shouldScrollUp && window.scrollTo({
    top: 0,
    behavior: 'instant',
  });
  dispatch({
    type: actionTypes.GET_USER_ACTIVITY,
    shouldBeReloaded,
  });
  const { loggedInUser: { userAuth }, calls: { sortBy, searchTerm } } = getState();
  try {
    const response = await user.getCalls(userAuth, isProCalls, sortBy, searchTerm, page).catch((err) => { throw err; });
    dispatch({
      type: actionTypes.GET_USER_ACTIVITY_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch(addNotification(error));
    dispatch({
      type: actionTypes.GET_USER_ACTIVITY_FAILURE,
      error,
    });
  }
};

export const changeSearchParams = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_ACTIVITY_SEARCH_PARAMS,
    payload: data,
  });
};

export const reset = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_ACTIVITY_SEARCH_PARAMS,
  });
};



// WEBPACK FOOTER //
// ./actions/calls.js